import { GET } from "@/lib/methods";
import type { Cart } from "../types/cart.type";

export const getCart = (cartId?: string) =>
  GET<Cart>({
    url: `${process.env.NEXT_PUBLIC_FOOAPP_URL}/cart/${cartId}`,
  });
